/**
 * Triads are a way to switch between useful units that are linked in a way that
 * the following equation is true: `UP / DOWN = RES`.
 * The name of the triad is usually written so that the 3 units appear in the order UP, DOWN, RES.
 * @example
 * Mass / Volume = Density
 */
const triad = () => ({
    getUp: (down, res) => (res * down),
    getDown: (up, res) => (up / res),
    getRes: (up, down) => (up / down),
});
export const massVolumeDensityTriad = triad();
export const distanceTimeSpeedTriad = triad();
export const speedTimeAccelerationTriad = triad();
export const forceMassAccelerationTriad = triad();
export const forceAreaPressureTriad = triad();
export const energyTimePowerTriad = triad();
export const energyDistanceForceTriad = triad();
export const energyVolumePressureTriad = triad();
export const powerSpeedForceTriad = triad();
export const powerVoltageCurrentTriad = triad();
export const voltageCurrentImpedanceTriad = triad();
//# sourceMappingURL=triads.js.map